import { AlertTriangle, ExternalLink } from "lucide-react";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function FallbackBanner() {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let active = true;
    const poll = () =>
      api
        .get("/arkcase/status")
        .then(({ data }) => active && setStatus(data))
        .catch(() => {});
    poll();
    const id = setInterval(poll, 30000);
    return () => {
      active = false;
      clearInterval(id);
    };
  }, []);

  if (!status || status.available) return null;

  return (
    <div
      data-testid="arkcase-fallback-banner"
      className="border-l-4 border-gold bg-gold/10 px-5 py-3 flex flex-wrap items-center gap-3 rounded-r-md"
    >
      <AlertTriangle className="h-4 w-4 text-gold shrink-0" />
      <p className="text-sm text-[#F3F4F6]">
        <span className="font-semibold text-gold">Live case system unavailable.</span>{" "}
        Showing the last synchronised case data{status.lastSynced ? ` (synced ${new Date(status.lastSynced).toLocaleString("en-GB")})` : ""}.
        Live updates resume automatically once the connection is restored.
      </p>
      {status.fallbackUrl ? (
        <a
          data-testid="arkcase-fallback-link"
          href={status.fallbackUrl}
          target="_blank"
          rel="noreferrer"
          className="ml-auto inline-flex items-center gap-1.5 text-xs font-medium text-gold hover:text-gold-soft transition-colors"
        >
          Open case system <ExternalLink className="h-3 w-3" />
        </a>
      ) : null}
    </div>
  );
}
